export const SET_STATE = 'SET_WORKOUT_TOGETHER_STATE' // To make it easy, but this is a bad api
export const RESET = 'RESET_WORKOUT_TOGETHER_STATE'

export const END_POINT = 'END_POINT_WORKOUT_TOGETHER'
export const WORKOUT_TOGETHER_REQUEST = 'REQUEST_WORKOUT_TOGETHER'

export const ADD_WORKOUTS = 'ADD_WORKOUTS'
